import tw from "twin.macro";

export const Container = tw.div`relative `;
export const ContentWithPaddingXl = tw.div`w-full relative bg-transparent mx-auto py-20 lg:py-24 `;
export const ContentWithPaddingLg = tw.div`max-w-screen-lg mx-auto py-20 lg:py-24`;
// export const ContentWithVerticalPadding = tw.div`w-full relative bg-transparent mx-auto py-20 lg:py-24 `;
export const Content2Xl = tw.div`max-w-screen-2xl mx-auto`;
export const ContentWithVerticalPadding = tw.div`w-full relative bg-transparent py-0 lg:py-0`;
